import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
// import ReactTooltip from 'react-tooltip';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Skills.scss';

/** Most recent first: ongoing (no stopyear) before ended; then by end year, then start year. */
const sortExperiencesByRecency = (items) => [...items].sort((a, b) => {
  const y = (v) => {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : 0;
  };
  const endA = a.stopyear ? y(a.stopyear) : 9999;
  const endB = b.stopyear ? y(b.stopyear) : 9999;
  if (endB !== endA) return endB - endA;
  return y(b.startyear) - y(a.startyear);
});

const Skills = () => {
  const [experiences, setExperiences] = useState([]);
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    const query = '*[_type == "experiences" && !(_id in path("drafts.**"))]';
    const skillsQuery = '*[_type == "skills" && !(_id in path("drafts.**"))]';

    client.fetch(query).then((data) => {
      setExperiences(sortExperiencesByRecency(data));
    });

    client.fetch(skillsQuery).then((data) => {
      setSkills(data);
    });
    return () => {
      setSkills([]); // This worked for me
      setExperiences([]); // This worked for me
    };
  }, []);

  return (
    <>
      <h2 className="head-text">Skills & Experiences</h2>

      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.length > 0 && skills.map((skill) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={skill?.name}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill?.bgColor }}
              >
                {skill.icon && <img src={urlFor(skill.icon)} alt={skill?.name} />}
              </div>
              <p className="p-text">{skill?.name}</p>
            </motion.div>
          ))}
        </motion.div>
        <div className="app__skills-exp">
          {experiences.length > 0 && experiences.map((experience) => (
            <motion.div
              className="app__skills-exp-item"
              key={experience._id}
            >
              <div className="app__skills-exp-year">
                <p className="bold-text">
                  {experience?.startyear}
                  {' - '}
                  {experience?.stopyear ?? 'Present'}
                </p>
              </div>
              <motion.div className="app__skills-exp-works">
                {experience?.works && experience.works.map((work) => (
                  <>
                    <motion.div
                      whileInView={{ opacity: [0, 1] }}
                      transition={{ duration: 0.5 }}
                      className="app__skills-exp-work"
                      data-tip
                      data-for={work.name}
                      key={work.name}
                    >
                      <h4 className="bold-text">{work.name}</h4>
                      <p className="p-text">{work.company}</p>
                      <p className="p-text">{work.desc}</p>
                    </motion.div>
                    {/* <ReactTooltip
                      id={work.name}
                      effect="solid"
                      arrowColor="#fff"
                      className="skills-tooltip"
                    >
                      {work.desc}
                    </ReactTooltip> */}
                  </>
                ))}
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, 'app__skills'),
  'skills',
  'app__whitebg',
);
